export default __webpack_public_path__ + "static/media/image 13.8758747c.png";